import React from 'react'
import shortid from 'shortid'
import { Button } from '@fortressiq/fiq-ds'

import Flash from 'components/flash/Flash'

// eslint-disable-next-line
export const miningRunImportSuccess = ({ miningRunId, processCount, processTypeName }) => {
  const messageText = [
    `Completed importing ${processCount}`,
    `${processTypeName} Process${processCount > 1 ? 'es' : ''}`,
    `for Mining Run ${miningRunId}`,
  ].join(' ')
  const id = shortid.generate()
  Flash.success(
    {
      description: messageText,
      message: 'Mining Run Finished',
      cta: (
        <Button type='link' href={`/mining?miningRunId=${miningRunId}`} size='small'>
          View Mining Run
        </Button>
      ),
    },
    { duration: 0, key: id }
  )
}
